<script setup lang="ts">
</script>

<template>
    <div
        class="ml-1 text-caption float-end text-medium-emphasis"
    >
        <v-icon size="small">
            mdi-rocket-launch-outline
        </v-icon>
        v<slot />
    </div>
</template>

<style scoped>

</style>
